"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UINT48_MAX = exports.SnakeNetFlagsV4 = exports.BotBehaviorV4 = exports.ChainFidelityV4 = exports.ServerMsgV4 = exports.ClientMsgV4 = exports.NETCODE_V4_SPARK_VIS_EXIT_RADIUS = exports.NETCODE_V4_SPARK_VIS_ENTER_RADIUS = exports.NETCODE_V4_REMOTE_FULL_MARGIN = exports.NETCODE_V4_CLOCK_HOLD_NEWEST_MS = exports.NETCODE_V4_CLOCK_UNSTABLE_SAMPLE_LIMIT = exports.NETCODE_V4_CLOCK_INSTABILITY_CLAMP_MS = exports.NETCODE_V4_CLOCK_INSTABILITY_JUMP_MS = exports.NETCODE_V4_CLOCK_OFFSET_ALPHA = exports.NETCODE_V4_CLOCK_HALF_RTT_ALPHA = exports.NETCODE_V4_MAX_SEGMENTS_PER_SNAKE = exports.NETCODE_V4_CHAIN_DELTA_QUANTIZATION = exports.NETCODE_V4_SELF_PREDICTION_LEAD_TICKS = exports.NETCODE_V4_INPUT_FUTURE_WINDOW_TICKS = exports.NETCODE_V4_INPUT_STALE_WINDOW_TICKS = exports.NETCODE_V4_MAX_CATCHUP_TICKS = exports.NETCODE_V4_RENDER_DELAY_TICKS = exports.NETCODE_V4_FIXED_DT_SECONDS = exports.NETCODE_V4_HEARTBEAT_RATE = exports.NETCODE_V4_BROADCAST_RATE = exports.NETCODE_V4_TICK_RATE = exports.NETCODE_V4_PROTOCOL_VERSION = void 0;
exports.splitUint48LE = splitUint48LE;
exports.combineUint48LE = combineUint48LE;
exports.normalizeRadians = normalizeRadians;
exports.signedUint32Delta = signedUint32Delta;
exports.NETCODE_V4_PROTOCOL_VERSION = 4;
exports.NETCODE_V4_TICK_RATE = 30;
exports.NETCODE_V4_BROADCAST_RATE = 20;
exports.NETCODE_V4_HEARTBEAT_RATE = 120;
exports.NETCODE_V4_FIXED_DT_SECONDS = 1 / exports.NETCODE_V4_TICK_RATE;
exports.NETCODE_V4_RENDER_DELAY_TICKS = 2;
exports.NETCODE_V4_MAX_CATCHUP_TICKS = 10;
exports.NETCODE_V4_INPUT_STALE_WINDOW_TICKS = 15;
exports.NETCODE_V4_INPUT_FUTURE_WINDOW_TICKS = 2;
exports.NETCODE_V4_SELF_PREDICTION_LEAD_TICKS = 2;
exports.NETCODE_V4_CHAIN_DELTA_QUANTIZATION = 0.25;
exports.NETCODE_V4_MAX_SEGMENTS_PER_SNAKE = 2048;
exports.NETCODE_V4_CLOCK_HALF_RTT_ALPHA = 0.2;
exports.NETCODE_V4_CLOCK_OFFSET_ALPHA = 0.1;
exports.NETCODE_V4_CLOCK_INSTABILITY_JUMP_MS = 66;
exports.NETCODE_V4_CLOCK_INSTABILITY_CLAMP_MS = 33;
exports.NETCODE_V4_CLOCK_UNSTABLE_SAMPLE_LIMIT = 5;
exports.NETCODE_V4_CLOCK_HOLD_NEWEST_MS = 250;
exports.NETCODE_V4_REMOTE_FULL_MARGIN = 320;
exports.NETCODE_V4_SPARK_VIS_ENTER_RADIUS = 7000;
exports.NETCODE_V4_SPARK_VIS_EXIT_RADIUS = 9000;
exports.ClientMsgV4 = {
    INPUT_V3: 0x01,
    PING_V3: 0x02,
    CHAIN_RESYNC_REQUEST_V3: 0x03,
    RESPAWN_REQUEST_V3: 0x04,
};
exports.ServerMsgV4 = {
    ASSIGN_SNAKE_V3: 0x40,
    SELF_HEAD_STATE_V3: 0x41,
    SELF_CHAIN_SNAPSHOT_V3: 0x42,
    REMOTE_CHAIN_BATCH_V3: 0x43,
    PONG_V3: 0x44,
    SPARK_BATCH_V3: 0x45,
    SPARK_REMOVE_V3: 0x46,
    GAME_STATE_V3: 0x47,
    DEATH_V3: 0x48,
    EVACUATION_V3: 0x49,
    SESSION_OVER_V3: 0x4A,
    GAME_END_V3: 0x4B,
    VIOLATION_WARNING_V3: 0x4C,
    DEATH_SCATTER_V1: 0x4D,
};
exports.ChainFidelityV4 = {
    FULL: 1,
    SPARSE: 2,
};
exports.BotBehaviorV4 = {
    NONE: 0,
    COLLECTING: 1,
    HUNT_APPROACH: 10,
    HUNT_FLANK: 11,
    HUNT_FEINT: 12,
    HUNT_CROSS: 13,
    HUNT_ENCIRCLE: 14,
    EVACUATING: 20,
};
exports.SnakeNetFlagsV4 = {
    ALIVE: 0x01,
    BOOSTING: 0x02,
    BOT: 0x04,
    INVULNERABLE: 0x08,
};
exports.UINT48_MAX = 0xFFFFFFFFFFFF;
const UINT32_MAX = 0x100000000;
const UINT16_MAX = 0x10000;
const UINT32_HALF_RANGE = 0x80000000;
function splitUint48LE(value) {
    if (!Number.isInteger(value) || value < 0 || value > exports.UINT48_MAX) {
        throw new RangeError(`u48 out of range: ${value}`);
    }
    const lo32 = value % UINT32_MAX;
    const hi16 = Math.floor(value / UINT32_MAX);
    return { lo32, hi16 };
}
function combineUint48LE(lo32, hi16) {
    if (!Number.isInteger(lo32) || lo32 < 0 || lo32 >= UINT32_MAX) {
        throw new RangeError(`u32 part out of range: ${lo32}`);
    }
    if (!Number.isInteger(hi16) || hi16 < 0 || hi16 >= UINT16_MAX) {
        throw new RangeError(`u16 part out of range: ${hi16}`);
    }
    return hi16 * UINT32_MAX + lo32;
}
function normalizeRadians(value) {
    if (!Number.isFinite(value))
        return 0;
    let angle = value;
    const twoPi = Math.PI * 2;
    while (angle > Math.PI)
        angle -= twoPi;
    while (angle < -Math.PI)
        angle += twoPi;
    return angle;
}
function signedUint32Delta(current, previous) {
    const currentU32 = current >>> 0;
    const previousU32 = previous >>> 0;
    let delta = currentU32 - previousU32;
    if (delta > UINT32_HALF_RANGE)
        delta -= UINT32_MAX;
    if (delta < -UINT32_HALF_RANGE)
        delta += UINT32_MAX;
    return delta;
}
//# sourceMappingURL=netcode-v4.js.map